import { render } from "./ProjectInfoItem.vue?vue&type=template&id=48405b22&scoped=true"
import script from "./ProjectInfoItem.vue?vue&type=script&lang=js"
export * from "./ProjectInfoItem.vue?vue&type=script&lang=js"

import "./ProjectInfoItem.vue?vue&type=style&index=0&id=48405b22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48405b22"]])

export default __exports__